module.exports = __webpack_public_path__ + "static/img/27.63b38c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/27.jpg
// module id = NeDv
// module chunks = 1